import _regeneratorRuntime from "/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(tryCatch),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(runSagas),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(runRouteDependencies),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(runRouteActions),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(routeRefresh);

import _ from 'lodash';
import pathToRegex from 'path-to-regexp';
import { put, select, all, takeEvery, takeLatest } from 'redux-saga/effects';
import { routingSelector } from '../selectors';
/**
 * Single saga runner, automatic try-catch with _COMPLETED, _SUCCEEDED, _FAILED event dispatches
 * @param type : String
 * @param saga : Generator
 * @returns {*} : Generator
 */

function tryCatch(type, saga) {
  var completed, succeeded, failed;
  return _regeneratorRuntime.wrap(function tryCatch$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          completed = function completed(action) {
            return {
              type: action.type + '_COMPLETED'
            };
          };

          succeeded = function succeeded(action, result) {
            return {
              type: action.type + '_SUCCEEDED',
              result: result
            };
          };

          failed = function failed(action, error) {
            return {
              type: action.type + '_FAILED',
              error: error
            };
          };

          _context2.next = 5;
          return takeLatest(type,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function invokeSaga() {
            var action,
                result,
                _args = arguments;
            return _regeneratorRuntime.wrap(function invokeSaga$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    action = _args.length <= 0 ? undefined : _args[0];
                    _context.prev = 1;
                    _context.next = 4;
                    return saga.apply(undefined, _args);

                  case 4:
                    result = _context.sent;
                    _context.next = 7;
                    return put(succeeded(action, result));

                  case 7:
                    _context.next = 13;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](1);
                    _context.next = 13;
                    return put(failed(action, _context.t0));

                  case 13:
                    _context.next = 15;
                    return put(completed(action));

                  case 15:
                  case 'end':
                    return _context.stop();
                }
              }
            }, invokeSaga, this, [[1, 9]]);
          }));

        case 5:
          return _context2.abrupt('return', _context2.sent);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked, this);
}
/**
 * Automatically invokes all given sagas for given event
 * Sagas: {[ActionType]: sagaHandler}
 * @param sagas : Object
 */


export function runSagas(sagas) {
  var handlers, actionKeys, i, type, saga;
  return _regeneratorRuntime.wrap(function runSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          handlers = [];
          actionKeys = _.keys(sagas);

          for (i = 0; i < actionKeys.length; i += 1) {
            type = actionKeys[i];
            saga = sagas[type];
            handlers.push(tryCatch(type, saga));
          }

          _context3.next = 5;
          return all(handlers);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked2, this);
}
/**
 * Function that matches path to template and returns object of paramters if matched
 * @param path : String
 * @param template : String
 * @returns params : Object
 */

function matchPathToTemplate(path, template) {
  var keys = [];
  var params = pathToRegex(template, keys).exec(path);

  var reducer = function reducer(res, x, i) {
    res[x.name] = params[i + 1];
    return res;
  };

  return params ? keys.reduce(reducer, {}) : null;
}
/**
 * Dependecies saga runner that runs sagaHandler for given route path if matches template
 * Sagas: {'template': sagaHandler}
 * @param sagas : Object
 * @param selector: (state: Object) => ({ pathname: String }: Object)
 */


export function runRouteDependencies(handlers) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : routingSelector;
  var routing, pathname, handlersToRun, template, params;
  return _regeneratorRuntime.wrap(function runRouteDependencies$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return select(selector);

        case 2:
          routing = _context4.sent;
          pathname = _.get(routing, 'pathname');

          if (!(typeof pathname !== 'string')) {
            _context4.next = 7;
            break;
          }

          console.warn('Pathname is expected to be string but is ' + (typeof pathname === 'undefined' ? 'undefined' : _typeof(pathname)) + '\nThis is likely caused by custom selector you have passed via parameters.');
          return _context4.abrupt('return');

        case 7:
          handlersToRun = []; // eslint-disable-next-line

          for (template in handlers) {
            params = matchPathToTemplate(pathname, template);

            if (params) {
              handlersToRun.push(handlers[template](params));
            }
          }

          _context4.next = 11;
          return all(handlersToRun);

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked3, this);
} // Alias for runRouteDependecies

export function runRouteActions(handlers, selector) {
  return _regeneratorRuntime.wrap(function runRouteActions$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return runRouteDependencies(handlers, selector);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked4, this);
}
/**
 * Saga to refresh route dependecies after action is done
 * @param {*} initType - intial action
 * @param {*} type - action to be dispatched into store
 * @param {*} handlers - viz. runRouteDependecies
 */

export function routeRefresh(initType, type, handlers) {
  return _regeneratorRuntime.wrap(function routeRefresh$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeEvery(initType,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee(action) {
            return _regeneratorRuntime.wrap(function _callee$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return put(_extends({}, action, {
                      type: type
                    }));

                  case 2:
                    _context6.next = 4;
                    return runRouteDependencies(handlers);

                  case 4:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee, this);
          }));

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked5, this);
}